import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";

import React, { useState, useEffect } from "react";
import moment from "moment";
import DeletePopup from "../shared/delete_popup";
import AccessLocalStorage from "../../services/localStorage";
import { getApiUrl } from "../../services/api_service";
import ViewEvent from "./view_event";
import { button, carejourneytabcontainer, carejourneytabheading, eventDateTime, eventDetails, eventTitle, lightpinkcolor, pcolor } from "../../style2";

export default function Todo() {
  const rowsPerPageValue = 4;
  const [todo, setTodos] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageValue);
  const [viewMore, setViewMore] = useState(false);
  const ls = new AccessLocalStorage();

  const [anchorEls, setAnchorEls] = useState([]);
  const [anchorPosition, setAnchorPosition] = useState(null);

  const [openEditTodo, setOpenEditTodo] = useState(false);
  const [openViewTodo, setOpenViewTodo] = useState(false);
  const [openAddTodo, setOpenAddTodo] = useState(false);
  const [openDeletePopup, setOpenDeletePopup] = useState(false);

  const [selectedTodo, setSelectedTodo] = useState([]);

  const handleViewMore = () => {
    viewMore ? setViewMore(false) : setViewMore(true);
    viewMore
      ? setRowsPerPage(rowsPerPageValue)
      : setRowsPerPage(todo.length);
  };

  const handleMenuClick = (event, index) => {
    const newAnchorEls = [...anchorEls];
    newAnchorEls[index] = event.currentTarget;
    setAnchorEls(newAnchorEls);
    const { left, top } = event.currentTarget.getBoundingClientRect();
    setAnchorPosition({ left, top });
  };
  const handleMenuClose = (index) => {
    const newAnchorEls = [...anchorEls];
    newAnchorEls[index] = null;
    setAnchorEls(newAnchorEls);
    setAnchorPosition(null);
  };
  const handleClickOpenEditTodo = (selectedTodo, index) => {
    setSelectedTodo(selectedTodo);
    setOpenEditTodo(true);
    //console.log("event edit id:", selectedTodo.id);
    handleMenuClose(index); // to close the menu after opening the edit popup
  };
  const handleClickOpenViewTodo = (selectedTodo) => {
    setSelectedTodo(selectedTodo);
    setOpenViewTodo(true);
    //console.log("event view id:", selectedTodo.id);
  };
  const handleClickAddTodo = () => {
    setOpenAddTodo(true);
  };
  const handleClickCloseTodo = () => {
    setOpenEditTodo(false);
    setOpenViewTodo(false);
    setOpenAddTodo(false);
    setSelectedTodo(""); // reset the selected event so the edit dialog will contain new data
  };

  const handleClickDeleteTodo = (id, index) => {
    handleMenuClose(index);
    setOpenDeletePopup(true);
    setTodos(
      todo.filter((Todo) => Todo.id !== id)
    );
    viewMore
      ? setRowsPerPage(rowsPerPageValue)
      : setRowsPerPage(todo.length);
  };

  const handleClickCloseDeletePopup = () => {
    setOpenDeletePopup(false);
  };
  // const getRandomColor = () => {
  //   const letters = '0123456789ABCDEF';
  //   let color = '#';
  //   for (let i = 0; i < 6; i++) {
  //     color += letters[Math.floor(Math.random() * 16)];
  //   }
  //   return color;
  // };
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const authTokens = localStorage.getItem("authTokens");
    let token;

    if (authTokens) {
      const parsedAuthTokens = JSON.parse(authTokens);
      token = parsedAuthTokens?.accessToken;
    }
    if (!token) {
      setError("Unauthorized. No token available.");
      setLoading(false);
      return;
    }

    fetch(
      `${getApiUrl()}${process.env.REACT_APP_GET_TODOS}/${ls.getCurrentPatientId()}/${"51019D31-C02F-486B-9429-DB63AFCEA442"}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
       //console.log(data);
        setTodos(data);
      })
      .catch((err) => {
        setError(err.message || "An error occurred.");
        setTodos([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <Box sx={{ position: "relative", padding: "0px" }}>
      <Grid container >
        <Grid item xs={11} >
          <Typography sx={carejourneytabheading}>To do</Typography>
        </Grid>
        {loading ? <Grid item xs={1}><CircularProgress /></Grid> : null}
      </Grid>
      <Box sx={carejourneytabcontainer}>
        {todo != null && todo.length > 0 ? todo.slice(0, rowsPerPage).map((Todo, index) => {
          return (
            <Grid
              container
              direction="row"
              alignItems="flex-start"
              key={Todo.id}
            >
              <Grid
                item
                xs={3}
                sx={{...eventDateTime, backgroundColor: lightpinkcolor }}>
                <div
                  onClick={() => handleClickOpenViewTodo(Todo)}
                  style={{
                    cursor: "pointer", textAlign: "center"
                  }}
                >
                  {/* <Typography>{Todo.startDate}</Typography>
                    <Typography>
                      {Todo.startDate} - {Todo.endDate}
                    </Typography> */}
                  <Typography  sx={{...eventTitle, color: pcolor }}>
                    {moment(Todo.startDate).format("DD.MM.YYYY")}
                  </Typography>
                  <Typography sx={{ fontSize: "14px", color: pcolor }}>
                    {moment(Todo.startDate).format("HH:mm A")} -{" "}
                    {moment(Todo.endDate).format("HH:mm A")}
                  </Typography>
                </div>
              </Grid>
              <Grid
                container
                item
                xs={9}
                alignItems="flex-start"
                justifyContent="space-between"
                sx={{...eventDetails, backgroundColor: lightpinkcolor }}
              >
                <Grid item xs={7} sm={9} md={10}>
                  <div
                    onClick={() => handleClickOpenViewTodo(Todo)}
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    <Typography  sx={{...eventTitle, color: pcolor }}>
                      {Todo.title != null ? Todo.title.length > 50 ? Todo.title.substring(0, 50) + "..." : Todo.title : null}
                    </Typography>
                    <Typography sx={{ color: "#535353", fontSize: "14px" }}>
                      {Todo.description != null ? Todo.description.length > 50
                        ? Todo.description.substring(0, 50) + "..." : Todo.description : null}
                    </Typography>
                  </div>
                </Grid>
                {/* <Grid item>
                    <IconButton
                      id={`basic-button-${index}`}
                      aria-controls={`basic-menu-${index}`}
                      onClick={(event) => handleMenuClick(event, index)}
                    >
                      <MoreVertIcon />
                    </IconButton>
                    <Menu
                      id={`basic-menu-${index}`}
                      anchorEl={anchorEls}
                      MenuListProps={{
                        "aria-labelledby": `basic-button-${index}`,
                      }}
                      open={Boolean(anchorEls[index])}
                      onClose={() => handleMenuClose(index)}
                      anchorPosition={anchorPosition}
                      anchorReference="anchorPosition"
                    >
                      <MenuItem
                        onClick={() =>
                          handleClickOpenEditTodo(Todo, index)
                        }
                        disableRipple
                      >
                        <EditIcon />
                        <Box m={1} />
                        Edit
                      </MenuItem>
                      <MenuItem
                        onClick={() =>
                          handleClickDeleteTodo(Todo.id, index)
                        }
                        disableRipple
                      >
                        <DeleteIcon />
                        <Box m={1} />
                        Delete
                      </MenuItem>
                    </Menu>
                  </Grid> */}
              </Grid>
            </Grid>
          );
        }) : loading ? null : <Box>No To do Events</Box>}
      </Box>
      <Box m={3} />
      <Grid
        container
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Grid item>
          {!viewMore && todo.length > rowsPerPageValue ? (
            <Button sx={button} onClick={handleViewMore}>
              Show More
            </Button>
          ) : (
            <Box m={4} />
          )}
        </Grid>
      </Grid>
      {/* <Fab
          color="primary"
          aria-label="add"
          size="medium"
          className={classes.floatingPlusIcon}
          onClick={handleClickAddTodo}
        >
          <AddIcon />
        </Fab> */}
      {/* <EditEvent
          open={openEditTodo}
          handleClose={handleClickCloseTodo}
          eventType={"Todo"}
          eventData={selectedTodo}
        /> */}
      <ViewEvent
        open={openViewTodo}
        handleClose={handleClickCloseTodo}
        eventType={"Todo"}
        eventData={selectedTodo}
      />
      {/* <EditEvent
          open={openViewTodo}
          handleClose={handleClickCloseTodo}
          eventType={"Todo"}
          eventData={selectedTodo}
          disabled={true}
        /> */}
      {/* <EditEvent
          open={openAddTodo}
          handleClose={handleClickCloseTodo}
          eventType={"Todo"}
          eventData={selectedTodo}
        /> */}
      <DeletePopup
        open={openDeletePopup}
        handleClose={handleClickCloseDeletePopup}
      />
    </Box>
  );
}
